module.exports = __webpack_public_path__ + "media/images/beatriz-1d67557e88f2a12ad6a82fef65c66b94.jpg";